import { UpdateSnapshotAdTypes } from '../../config'
import { BaseBadge } from './BaseBadge'
import React from 'react'

const updateSnapshotAdType = {
    [UpdateSnapshotAdTypes.Campaigns]: { text: 'Campaigns', intent: 'success' },
    [UpdateSnapshotAdTypes.AdGroups]: { text: 'Ad Groups', intent: 'warning' },
    [UpdateSnapshotAdTypes.Keywords]: { text: 'Keywords', intent: 'primary' },
    [UpdateSnapshotAdTypes.NegativeKeyword]: { text: 'Negative Keywords', intent: 'danger' },
    [UpdateSnapshotAdTypes.CampaignNegativeKeywords]: {
        text: 'Campaign Negative Keywords',
        intent: 'danger',
    },
    [UpdateSnapshotAdTypes.ProductAds]: { text: 'Product Ads', intent: 'warning' },
    [UpdateSnapshotAdTypes.Targets]: { text: 'Targets', intent: 'warning' },
    [UpdateSnapshotAdTypes.NegativeTargets]: { text: 'Negative Targets', intent: 'danger' },
}
export const UpdateSnapshotAdType = ({ type }) => {
    return <BaseBadge value={type} options={updateSnapshotAdType} />
}
